/* eslint-disable camelcase */
import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import { getQueryVal, getUrlParams, getUrlQueryObj } from '@/assets/js/utils'
import { finderEvtCollect } from '@/assets/js/finder'
import { GetUserToken } from '@/query/api'

Vue.use(Router)
let basePath = ''
if (process.env.NODE_ENV === 'production') {
    basePath = '/activityRefactoring/'
} else {
    basePath = '/activityRefactoring/'
}
const router = new Router({
    mode: 'history',
    // mode: 'hash',
    base: basePath,
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home/:id',
            name: 'home',
            component: home
        }
    ]
})

router.beforeEach((to, from, next) => {
    let activitySource = to.query.activitySource || ''
    localStorage.setItem('firstEnterTime', new Date().getTime())
    localStorage.setItem('activitySource', activitySource)
    let getTicketTime = localStorage.getItem('getTicketTime') // 上次成功获取优惠券的时间

    const utm_source = getQueryVal('utm_source')
    if (utm_source) {
        finderEvtCollect('config', {
            utm_source
        })
    }

  console.log('-------to------', to)
  const ticket = getQueryVal('ticket')
  if (ticket) {
    GetUserToken({ ticket }).then(({data}) => {
      if (data.result.token) {
        const param = getUrlParams(to.fullPath)
        delete param.ticket
        param.token = data.result.token
        next(getUrlQueryObj(to.path, param))
      } else {
        next()
      }
    }, () => {
      next()
    })
  } else {
    // 领取时间过去7天或者领取时间不存在重置所有本地缓存
    if (!getTicketTime || (getTicketTime && (Date.now() - getTicketTime) > (10000))) {
      if (window.Prius && window.Prius.isInsideApp) {
          window.localStorage.clear()
          window.localStorage.setItem('version', '2.6.0')
      }
  }
  next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js